module.exports = __webpack_public_path__ + "static/img/grid.18b301c0.svg";